export const textChartFormatData = data => {
  if (
    !data ||
    data === 'null' ||
    data === 'undefined' ||
    data === '-' ||
    data === 'NA'
  ) {
    return {
      curent: 0,
      max: 0
    };
  } else {
    const index = data.indexOf('/');
    const current = +data.slice(0, index);
    const max = +data.slice(index + 1);
    return {
      current: current,
      max: max
    };
  }
};
